import { Link } from '@tanstack/react-router';
import { LabelXBase } from '@/components/LabelX';
import { ProductLogoSmallContracts } from '@/components/Logo/Product/ProductLogoSmallContracts';
import { Text } from '@/components/Typography/Text';
import type { ContractValue } from '@/features/section-attribute/types';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  value: ContractValue;
  onChange: (value: ContractValue) => void;
};
export const CFormContractItem = buildCFormItem((props: Props) => {
  const value = props.value;
  const readComponent = value.contractAggregateId ? <Link to="/contract/$id" params={{
    id: value.contractAggregateId
  }} target="_blank">
      <LabelXBase label={value.name} size="Large" className="cursor-pointer hover:opacity-80 transition-opacity">
        <ProductLogoSmallContracts size={20} />
      </LabelXBase>
    </Link> : <Text variant="labelLarge">{value.name}</Text>;
  return <CFormItemBase {...props} readComponent={readComponent}
  // Contract is always read-only; reuse readComponent for write mode
  writeComponent={readComponent} />;
});